<footer class="w-full">
  <div class="bg-appBgrd w-full py-14 md:py-24">
    <div
      class="flex flex-col gap-x-2 gap-y-8 md:flex-row sub-section-container"
    >
      <div
        class="flex flex-col md:items-start items-center md:w-1/2"
      >
        <h2 class="sub-section-header">
          {{ 'footer.lineOne' | translate }}
        </h2>
        <p class="sub-section-desc">
          {{ 'footer.lineTwo' | translate }}
        </p>
        <button
          class="outline-button !bg-appBgrd hover:!bg-primary-default text-lg mt-6"
          (click)="goToLandingPage()"
        >
          {{ 'footer.cta' | translate }}
        </button>
      </div>
      <div
        class="flex justify-center items-center gap-x-10 gap-y-6 md:w-1/2 flex-wrap"
      >
        <img
          src="https://d1zl99f7e5jysh.cloudfront.net/image/992382361685/image_mopshakvvt1jb3p2r1572k1g61/-FPNG"
          alt="logo"
          class="h-8 md:h-10"
        />
        <img
          src="https://d1zl99f7e5jysh.cloudfront.net/image/992382361685/image_1o0rv6k4e16o74tiigb6rv462b/-FPNG"
          alt="logo"
          class="h-8 md:h-10"
        />
        <img
          src="https://d1zl99f7e5jysh.cloudfront.net/image/992382361685/image_1vk61as2kd6613u3h3amq4j76n/-FPNG"
          alt="logo"
          style="height: 80px"
        />
      </div>
    </div>
  </div>
  <app-end-footer></app-end-footer>
</footer>
